import { render, staticRenderFns } from "./ApplicantsFeedbackTable.vue?vue&type=template&id=28a72885&"
import script from "./ApplicantsFeedbackTable.vue?vue&type=script&lang=js&"
export * from "./ApplicantsFeedbackTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports